module.exports = __webpack_public_path__ + "img/youpaq-nestle-logo-home.830190e3.png";